export const MAX_AI_GENERATED_QUESTIONS_COUNT = 20;
export const MIN_AI_GENERATED_QUESTIONS_COUNT = 5;
export const INITIAL_AI_GENERATED_QUESTIONS_COUNT = 10;
export const STEP_AI_GENERATED_QUESTIONS_COUNT = 1;
